import Model from '@/models/Model.js';

export default class FileSubmissionActivityTemplate extends Model {
    static entity = 'file_submission_activity_templates';

    static modelName = 'FileSubmissionActivityTemplate';

    static fields() {
        return {
            content: this.attr(null),
            min_files: this.attr(null),
            max_files: this.attr(null),
            file_types: this.attr(null),

            ...super.fields(),
        };
    }
}
